<template>
  <div class="versions">
    <!-- 输入密钥 -->
    <div class="versions-password" v-if="!isPassword">
      <div class="password-box">
        <p class="title">请输入密码</p>
        <el-input
          v-model="queryParams.accessPassword"
          type="password"
          placeholder="请输入密码"
          clearable
          @keyup.enter.native="submitPassword"
          class="password-input"
          show-password
        />
        <el-button
          type="primary"
          class="submit-btn"
          @click="submitPassword"
          :loading="loading"
        >
          确认
        </el-button>
        <p class="tip" v-if="errorMsg">{{ errorMsg }}</p>
      </div>
    </div>
    <div class="btn-box">
      <el-button
        v-if="isPassword"
        class="add-btn"
        @click="add"
        icon="el-icon-plus"
        >生成设备激活码</el-button
      >
    </div>
    <div class="versions-box">
      <div class="top">
        <div class="querybox">
          <div>
            <p>生成人：</p>
            <el-input
              v-model="queryParams.founder"
              placeholder="请输入生成人"
              clearable
            ></el-input>
          </div>
          <div>
            <p>生成状态：</p>
            <el-select
              v-model="queryParams.createStatus"
              placeholder="请选择生成状态"
            >
              <el-option
                v-for="item in getDictDatas(DICT_TYPE.CREATE_STATUS)"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <!-- <div>
          <p>生成日期：</p>
          <el-date-picker
            v-model="dateValue"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
            :default-time="['00:00:00', '23:59:59']"
            @change="timeChange"
          >
          </el-date-picker>
        </div> -->
        </div>
        <div class="handlebox">
          <div class="btnbox">
            <el-button
              type="primary"
              icon="el-icon-refresh-right"
              class="reset-btn"
              @click="resetFn"
              >重置</el-button
            >
            <el-button
              type="primary"
              icon="el-icon-search"
              class="search-btn"
              @click="search"
              >查询</el-button
            >
          </div>
        </div>
      </div>
      <div class="content">
        <el-table
          :data="tableData"
          tooltip-effect="dark"
          :header-cell-style="{ 'text-align': 'center' }"
          :cell-style="{ 'text-align': 'center' }"
        >
          <el-table-column prop="founder" label="生成人"></el-table-column>
          <el-table-column prop="createTitle" label="生成标题">
          </el-table-column>
          <el-table-column prop="createQuantity" label="生成数量">
          </el-table-column>
          <el-table-column prop="createStatus_dictText" label="生成状态">
            <template slot-scope="{ row }">
              <p
                :style="{
                  color:
                    Number(row.createStatus) === 1
                      ? '#008000'
                      : Number(row.createStatus) === 2
                      ? '#FF0000'
                      : '#0000CD',
                }"
              >
                {{ row.createStatus_dictText }}
              </p>
            </template>
          </el-table-column>
          <el-table-column prop="remarks" label="备注"> </el-table-column>
          <el-table-column prop="createdTime" label="创建时间">
          </el-table-column>
          <el-table-column label="操作" fixed="right" min-width="100">
            <template slot-scope="{ row }">
              <el-button
                class="textOrange-btn"
                @click="checkRecord(row.id, row.createTitle)"
                >查看</el-button
              >
              <!-- <el-button
              class="textOrange-btn"
              @click="exportPdf(row.id, row.createTitle)"
              >导出</el-button
            > -->
              <el-popover
                placement="top"
                trigger="click"
                :value="activePopoverRowId === row.id"
                @show="handlePopoverShow(row.id)"
                @hide="closePopover"
                append-to-body
              >
                <div style="margin-bottom: 10px">
                  <el-select
                    v-model="row.language"
                    placeholder="选择导出类型"
                    size="mini"
                    style="width: 150px"
                  >
                    <el-option
                      v-for="item in getDictDatas(DICT_TYPE.LANGUAGE)"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </div>
                <div style="text-align: right">
                  <el-button size="mini" @click="closePopover">
                    取消
                  </el-button>
                  <el-button size="mini" type="primary" @click="exportPdf(row)">
                    确定
                  </el-button>
                </div>

                <!-- 触发按钮 -->
                <el-button slot="reference" class="textOrange-btn" @click.stop>
                  导出
                </el-button>
              </el-popover>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <pagination
          v-show="total > queryParams.pageSize"
          :total="total"
          :page.sync="queryParams.pageNum"
          :limit.sync="queryParams.pageSize"
          @pagination="init"
        />
      </div>
    </div>
    <!-- 添加质检员 -->
    <el-dialog
      :visible.sync="descriptionVisible"
      title="生成设备激活码"
      :before-close="handleClose"
      destroy-on-close
      :show-close="false"
      width="40%"
    >
      <div slot="title" class="title">
        <p>生成设备激活码</p>
        <span @click="handleClose"><i class="el-icon-close"></i></span>
      </div>
      <div class="agree-content">
        <el-form
          :model="activationForm"
          :rules="activationRules"
          ref="activationForm"
          class="demo-activationForm"
          label-position="left"
          label-width="120px"
        >
          <el-form-item label="生成标题：" prop="createTitle">
            <el-input
              v-model="activationForm.createTitle"
              placeholder="请输入生成标题"
            ></el-input>
          </el-form-item>
          <el-form-item label="生成数量：" prop="createQuantity">
            <el-input
              v-model="activationForm.createQuantity"
              placeholder="请输入生成数量"
            ></el-input>
          </el-form-item>
          <el-form-item label="备注：">
            <el-input
              v-model="activationForm.remarks"
              placeholder="请输入备注"
            ></el-input>
          </el-form-item>
          <el-form-item class="handlebox">
            <el-button
              type="primary"
              @click="submitForm('activationForm')"
              class="enter-btn save-btn"
              :loading="submitLoading"
              >保存</el-button
            >
            <el-button
              @click="resetForm('activationForm')"
              class="cancel-btn calloff-btn"
              >取消</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getActivationCodeRecord,
  addActivationCode,
  getActivationCodePdf,
} from "@/api/device";
export default {
  data() {
    return {
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        createStatus: "",
        founder: "",
        endTime: "",
        startTime: "",
        accessPassword: "",
      },
      tableData: [],
      total: 0, //总数
      descriptionVisible: false,
      activationForm: {
        createTitle: "",
        remarks: "",
        createQuantity: "",
      },
      activationRules: {
        createTitle: [
          { required: true, message: "请输入生成标题", trigger: "blur" },
          {},
        ],
        createQuantity: [
          { required: true, message: "请输入生成数量", trigger: "blur" },
          {},
        ],
      },
      submitLoading: false,
      allQuality: { all: 0, todayAll: 0 },
      dateValue: "",
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      activePopoverRowId: null,
      isPassword: false,
      password: "",
      errorMsg: "",
      loading: false,
    };
  },
  created() {
    this.init();
  },
  mounted() {},
  methods: {
    //获取设备激活码记录
    async init() {
      const verified = sessionStorage.getItem("passwordVerified");
      if (verified) {
        this.queryParams.accessPassword = this.aes_decrypt(verified);
        this.isPassword = true;
        // this.submitPassword()
      }
      if (!this.isPassword) return;
      const res = await getActivationCodeRecord(this.queryParams);
      this.tableData = res.result.records.map((el) => {
        return {
          ...el,
          language: "",
        };
      });
      this.total = res.result.total;
    },
    async submitPassword() {
      if (!this.queryParams.accessPassword) {
        this.errorMsg = "密码不能为空";
        return;
      }
      this.errorMsg = "";
      this.loading = true;
      getActivationCodeRecord(this.queryParams)
        .then((res) => {
          this.tableData = res.result.records.map((el) => {
            return {
              ...el,
              language: "",
            };
          });
          this.total = res.result.total;
          this.loading = false;
          this.isPassword = true;
          sessionStorage.setItem(
            "passwordVerified",
            this.aes_encrypt(this.queryParams.accessPassword)
          );
        })
        .catch(() => {
          this.errorMsg = "密码错误，请重试！";
          this.loading = false;
        });
    },
    handleClose() {
      this.descriptionVisible = false;
    },
    // 添加
    add() {
      this.descriptionVisible = true;
    },
    // 生成设备激活码
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          this.submitLoading = true;
          const params = this.activationForm;
          await addActivationCode(params);
          this.$message.success("生成成功！");
          this.submitLoading = false;
          this.resetForm(formName);
          this.resetFn();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      // console.log(formName);
      this.$refs[formName].resetFields();
      this.handleClose();
    },
    // 查询
    search() {
      this.queryParams.pageNum = 1;
      this.init();
    },
    //重置
    resetFn() {
      this.queryParams.founder = "";
      this.queryParams.createStatus = "";
      this.queryParams.pageNum = 1;
      this.dateValue = "";
      this.queryParams.endTime = "";
      this.queryParams.startTime = "";
      this.init();
    },
    timeChange(event) {
      // console.log(event);
      if (event) {
        this.queryParams.startTime = this.$moment(event[0]).format(
          "YYYY-MM-DD HH:mm:ss"
        );
        this.queryParams.endTime = this.$moment(event[1]).format(
          "YYYY-MM-DD HH:mm:ss"
        );
      } else {
        this.queryParams.startTime = "";
        this.queryParams.endTime = "";
      }
      // console.log(this.queryParams);
    },
    // 查看激活码
    checkRecord(id, createTitle) {
      this.$router.push({
        path: "/codelist",
        query: {
          id,
          createTitle,
        },
      });
    },
    handlePopoverShow(id) {
      // 如果点击的是另一个 Popover，先关掉当前的
      if (this.activePopoverRowId !== id) {
        this.activePopoverRowId = null;
        this.$nextTick(() => {
          this.activePopoverRowId = id;
        });
      } else {
        // 点击同一个则直接打开
        this.activePopoverRowId = id;
      }
    },
    closePopover() {
      this.activePopoverRowId = null; // 关闭所有
    },
    // exportPdf(row) {
    //   if (!row.language) {
    //     this.$message.warning('请选择导出类型');
    //     return;
    //   }
    //   console.log('导出 PDF', row.language, row.id);
    //   this.closePopover();
    // }
    // 导出
    async exportPdf(row) {
      if (!row.language) {
        this.$message.warning("请选择导出语言");
        return;
      }
      // console.log(row);
      this.closePopover();
      const res = await getActivationCodePdf(row.id, row.language);
      // 处理响应数据
      const blob = new Blob([res], {
        type: "application/pdf",
      });

      // 获取文件名（从 headers 中提取，兼容中文名）
      let filename = `${row.createTitle}.pdf`;
      const disposition =
        res.headers?.["content-disposition"] ||
        res.headers?.get?.("content-disposition");
      if (disposition) {
        const match = disposition.match(/filename\*?=(?:UTF-8'')?(.+)/);
        if (match && match[1]) {
          filename = decodeURIComponent(match[1]);
        }
      }

      // 生成下载链接
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      link.style.display = "none";

      document.body.appendChild(link);
      link.click();

      // 清理资源
      URL.revokeObjectURL(link.href);
      document.body.removeChild(link);
    },
  },
};
</script>
<style lang="scss" scoped>
.versions {
  // position: relative;
  ::v-deep .versions-password {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(135, 135, 135, 0.8);
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
    .password-box {
      background: #fff;
      padding: 30px 40px;
      border-radius: 12px;
      box-shadow: 0 6px 15px rgba(0, 0, 0, 0.3);
      width: 320px;
      // text-align: center;
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .title {
      font-size: 20px;
      font-weight: bold;
      color: #333;
      margin-bottom: 20px;
    }

    .password-input {
      margin-bottom: 20px;
      width: 100%;
    }

    .submit-btn {
      padding: 10px 48px;
      border-radius: 8px;
      display: flex;
      align-items: center;
      span {
        display: block;
        font-size: 16px;
        font-weight: bold;
      }
    }

    .tip {
      margin-top: 12px;
      color: #f56c6c;
      font-size: 14px;
    }
  }

  .top {
    display: flex;
    justify-content: space-between;
    padding-bottom: 32px;
    ::v-deep .querybox {
      display: flex;
      align-items: center;
      width: 0;
      flex: 1;
      // justify-content: space-around;
      > div {
        display: flex;
        align-items: center;
        padding-right: 20px;
        p {
          font-weight: 400;
          font-size: 14px;
          color: #262626;
          line-height: 20px;
          white-space: nowrap;
        }
        // display: flex;
        // align-items: center;
        // margin-right: 24px;

        // .el-input {
        //   width: 180px;
        // }
        // input::-webkit-input-placeholder {
        //   /* WebKit browsers */
        //   color: rgba(0, 0, 0, 0.25);
        // }
        // .el-input__inner {
        //   background: #ffffff;
        //   border-radius: 4px;
        //   border: 1px solid #d9d9d9;
        // }
      }
    }
    .handlebox,
    .btnbox {
      display: flex;
      align-items: center;
      flex-wrap: nowrap;
    }
  }
  .btn-box {
    position: absolute;
    top: -88px;
    right: 0;
    display: flex;
    align-items: center;
    .total-box {
      display: flex;
      align-items: center;
      margin-right: 90px;
      p {
        font-size: 16px;
        display: flex;
        align-items: flex-end;
        margin-right: 40px;
        span {
          display: inline-block;
          font-size: 22px;
          font-weight: bold;
        }
      }
    }
  }
  ::v-deep(.el-dialog) {
    .el-dialog__body {
      display: flex;
      align-items: center;
      justify-content: center;
      .agree-content {
        width: 100%;
        display: flex;
        justify-content: center;
      }
      .OutBtnBox {
        margin-top: 10px;
        text-align: center;
      }
    }
  }
  ::v-deep .demo-activationForm {
    width: 80%;
    .el-form-item {
      display: flex;
      align-items: center;
    }
    .el-form-item__label {
      white-space: nowrap;
      min-width: 100px !important;
      font-weight: 400;
      font-size: 14px;
      color: #262626;
      text-align: right;
    }
    .el-form-item__content {
      width: 0;
      flex: 1;
      margin: 0 !important;
    }
    .handlebox {
      text-align: right;
      margin-top: 50px;
    }
    // .el-input {
    //   width: 380px;
    // }
  }
  .textOrange-btn {
    padding: 0 5px;
  }
}
</style>
